import hapanaPattern from '@hapana/shared/web/styles/assets/images/hapana-pattern.png'

/** @type {Styles} */

export const styles = {
  form: {
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: 'primary.main',
    height: '100%',
    alignItems: 'center',
    position: 'relative',
    gap: 5,
    paddingX: 2.5,
  },
  flexCenter: { display: 'flex', justifyContent: 'center' },
  logo: { height: 'auto', width: 216 },
  credentialsContainer: {
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 5,
    marginTop: { xs: 3, md: 4 },
    borderColor: 'custom.blue.light',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
  title: { color: 'custom.blue.light' },
  button: { width: '100%' },
  forgotPasswordLabel: { color: 'custom.blue.light' },
  getHelpSigningLabel: { color: 'primary.main', cursor: 'pointer' },
  subtitle: { color: 'custom.blue.light' },
  formRoot: {
    width: { xs: '100%', md: 438 },
    backgroundColor: 'navy.deep',
    zIndex: 1,
  },
  backgroundPatternImage: {
    backgroundImage: `url(${hapanaPattern})`,
    position: 'absolute',
    height: 248,
    width: '100%',
    bottom: 0,
  },
}

/* eslint-disable no-restricted-syntax -- Google sign-in button keeps Google's branded light colours */
const GOOGLE_BUTTON_COLOURS = {
  background: '#FFFFFF',
  text: '#3C4043',
  border: '#E4E4E5',
  hoverBackground: '#F8F9FA',
  hoverBorder: '#DBDBDC',
}
/* eslint-enable no-restricted-syntax */

export const loginFormStyles = {
  error: {
    backgroundColor: 'status.danger.background',
    border: '1px solid',
    borderColor: 'alert.danger.lightest',
    borderRadius: 1,
    padding: 1.5,
    color: 'status.danger.text',
  },
  googleWrapper: { width: '100%' },
  orDivider: { color: 'gray.64', fontSize: '0.875rem' },
  googleButton: {
    backgroundColor: GOOGLE_BUTTON_COLOURS.background,
    color: GOOGLE_BUTTON_COLOURS.text,
    border: `1px solid ${GOOGLE_BUTTON_COLOURS.border}`,
    '&:hover': {
      backgroundColor: GOOGLE_BUTTON_COLOURS.hoverBackground,
      border: `1px solid ${GOOGLE_BUTTON_COLOURS.hoverBorder}`,
    },
  },
  helpLinks: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
}
